module.exports = require("@inquirer/prompts");